module.exports = __webpack_public_path__ + "img/reject.a279577b.png";